import React from "react";
import PropTypes from "prop-types";

import { MaterialUIGridContainer, H6New } from "../index";
import {
    BulletGridItem,
    Paragraph,
    SectionHeading,
    SectionHeadingGridItem
} from "./styles";

const Content = ({ bullets, sectionHeading }) => {
    return (
        <MaterialUIGridContainer
            mobileMaxPadding={9}
            // passing in index 9 passes in the number "48" from the spacing array divided by 2 = 48px gutter as 24px around each item (see line 9 of js/components/shared/materialUI.js for this spacing array)
            tabletMaxPadding={4}
            // passing in index 4 passes in the number "20" from the spacing array divided by 2 = 20px gutter as 10px around each item (see line 9 of js/components/shared/materialUI.js for this spacing array)
            desktopMinPadding={9}
            // passing in index 9 passes in the number "48" from the spacing array divided by 2 = 48px gutter as 24px around each item (see line 9 of js/components/shared/materialUI.js for this spacing array)
        >
            {sectionHeading && (
                <SectionHeadingGridItem sm={12}>
                    <SectionHeading>{sectionHeading}</SectionHeading>
                </SectionHeadingGridItem>
            )}
            {bullets.map(bullet => {
                return (
                    <BulletGridItem
                        item
                        sm={12}
                        md={4}
                        lg={4}
                        key={bullet.title}
                    >
                        {bullet.icon}
                        <H6New>{bullet.title}</H6New>
                        <Paragraph>{bullet.text}</Paragraph>
                    </BulletGridItem>
                );
            })}
        </MaterialUIGridContainer>
    );
};

Content.propTypes = {
    bullets: PropTypes.array.isRequired,
    sectionHeading: PropTypes.string
};

export default Content;
